import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Amount from 'sharedWebpack/Amount';
import './styles.scss';

const ShowGrossTotalPrice = ({
  availabilityIcon,
  currency,
  grossTotal,
  exchangePrice,
  exchangeCurrency,
}) => (
  <div className="d-flex column-gap-8 align-center">
    {availabilityIcon && availabilityIcon}
    <Amount
      className="gross-total-price"
      currency={exchangeCurrency || currency}
      value={exchangePrice || grossTotal}
    />
  </div>
);

const mapStateToProps = state => ({
  exchangePrice: state.flights.currentExchangeQuote?.totalNewPriceWithoutPenalty?.amount,
  exchangeCurrency: state.flights.currentExchangeQuote?.totalNewPriceWithoutPenalty?.currency,
});

ShowGrossTotalPrice.defaultProps = {
  availabilityIcon: null,
  exchangeCurrency: null,
  exchangePrice: null,
};

ShowGrossTotalPrice.propTypes = {
  availabilityIcon: PropTypes.node,
  currency: PropTypes.string.isRequired,
  grossTotal: PropTypes.string.isRequired,
  exchangePrice: PropTypes.string,
  exchangeCurrency: PropTypes.string,
};

export default connect(mapStateToProps)(ShowGrossTotalPrice);
